/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-06-16 19:50:20
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-08 09:56:08
 * @FilePath: \baishu_react_ui\src\components\BsyFormPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { createRef } from "react";

import "./index.css";
import { BsyWidget } from "../BsyWidget";
import BsyFormData from "../BsyFormData";
import BsyForm from "../BsyForm";
import { BsyUtils } from "../../utils/Utils";
import BsyAlert from "../BsyAlert";
import { BsyConfig } from "../../global/BsyConfig";
import BsyIconBtn from "../BsyIconBtn";
import BsyMaskLayer from "../BsyMaskLayer";
import BsySLoading from "../BsySLoading";
import _ from "lodash";

class BsyFormPane extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-form-pane",
      width: props.width || "80%",
      // ...props
    });
    this.config = { ...props };
    this.state = {
      isFlow: props.isFlow || false,
      mode: props.mode || "view",
      loading: props.loading === undefined ? true : false,
      formConfig: props.formConfig,
      authGroupId: props.authGroupId,
      ignoreAuth: props.ignoreAuth,
      ignoreOptAuth: props.ignoreOptAuth,
      ignoreValidate: props.ignoreValidate,
      submitType: "",
      submitDatas: {},
      buttonPosition: props.buttonPosition || "left",
    };
    this.renderFormDataIndex = 0;
    this.renderFormIndex = 0;
    this.isEdit = false;
    //记录，当有多层弹出规则
    this.showForms = [this.config];
    this.showFormIndex = 0;
    this.formdataElement = createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    const { formConfig } = this.state;

    const { mode } = this.state;
    switch (mode) {
      case "copy":
      case "new": {
        if (!BsyUtils.isObjectEmpty(formConfig)) {
          this.options.width = formConfig.content.width || "100%";
          this.setState({ loading: false });
        } else this.readForm();
        break;
      }

      case "edit":
        if (!BsyUtils.isObjectEmpty(formConfig)) {
          this.options.width = formConfig.content.width || "100%";
          this.setState({ loading: false });
        } else {
          this.readData();
        }
        break;

      default:
        this.setState({ loading: false });
    }
  }

  readForm = () => {
    this.renderFormIndex++;
    const { mode } = this.state;
    this.config = this.showForms[this.showFormIndex];
    let {
      appId,
      _id,
      dataId,
      entryId,
      flowId,
      flowType,
      formId,
      authGroupId,
      popupFormPath,
      refAppId,
    } = this.config;
    let n = {
      appId,
      dataId: _id || dataId,
      entryId,
      flowId,
      flowType,
      authGroupId,
      popupFormPath,
      formId,
      refAppId,
    };

    React.axios(
      "/dashboard/app/" + (refAppId ? refAppId : appId) + "/entry/" + formId,
      n
    )
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            const h = res ? res.data.entry : {};

            window.FX.STATIC.appId = h.appId;
            window.FX.STATIC.entryId = h.entryId;
            window.FX.STATIC.INNERLINK = h._id;

            if (!BsyUtils.isObjectEmpty(h.href)) {
              window.FX.STATIC.FORMHREF = h.href;
            } else {
              window.FX.STATIC.FORMHREF = null;
            }

            let formConfig = {
              ...h,
              appId: h.appId,
              entryId: h.entryId,
              is_dock_form: res.data.is_dock_form,
            };

            formConfig.content.width = "80%";
            formConfig.content.name = h.name;
            formConfig.content.ignoreOptAuth = this.props.ignoreOptAuth;
            formConfig.content.ignoreValidate = this.props.ignoreValidate;
            formConfig.content.ignoreAuth = this.props.ignoreAuth;
            if (mode === "copy") {
              formConfig.content.editValue = this.config.data;
            }

            this.setState({
              mode: mode || "new",
              loading: false,
              formConfig: formConfig,
            });
          },
          () => {}
        );
      })
      .catch(() => {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.config.onClose && this.config.onClose();
          }
        );
      });
  };

  readData = () => {
    this.renderFormIndex++;
    let that = this;
    this.config = this.showForms[this.showFormIndex];
    // TODO authGroupId不能设置默认值
    let {
      appId,
      // _id,
      dataId,
      entryId,
      flowId,
      flowType,
      formId,
      authGroupId,
      ignoreOptAuth,
      popupFormPath,
      data,
      widgetOptAuth,
      dataPerms,
      refAppId,
    } = this.config;
    let n = {
      appId,
      dataId: dataId,
      entryId,
      flowId,
      flowType,
      authGroupId,
      popupFormPath,
      refAppId,
      formId: formId ? formId : entryId,
    };
    if (n.authGroupId === -99) {
      delete n.authGroupId;
    }
    const url =
      flowType === "launch"
        ? `/dashboard/app/${appId}/entry/${entryId}`
        : ((n = { ...n, widgetId: this.props.widgetId }), "/data/read");

    React.axios(url, n)
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            that.props.onShowDocumentTitle &&
              that.props.onShowDocumentTitle(res.data.formName);
            window.FX.STATIC.DATAID = res.data.data ? res.data.data._id : null;
            let optAuth = res.data.optAuth;
            let formConfig = {};
            if (!flowType) {
              let tmpoptAuth = that.config.optAuth || widgetOptAuth;
              if (authGroupId === 0) {
                tmpoptAuth = { ...that.config.optAuth, ...data.optAuth };
              }
              if (
                that.config.hasOwnProperty("sourceType") &&
                ["data_table", "newrili", "gantt", "newMap", "card"].includes(
                  that.config.sourceType
                )
              ) {
                //报表 可编辑权限根据报表设计走
                tmpoptAuth = { ...data.optAuth };
                //有权限组值才会走 判断
                authGroupId = -99;
              }
              if (that.config.rowdata) {
                tmpoptAuth = that.config.optAuth || widgetOptAuth;
                authGroupId = null;
              }
              let optAuth = { ...tmpoptAuth };

              if (res.data.hasOwnProperty("optAuth")) {
                optAuth = { ...optAuth, ...res.data.optAuth }; //$.extend({}, optAuth, g.optAuth)
              }
              window.FX.STATIC.IS_EVENT = res.data.isEvent === true;
              if (res.data.submitRule === 1) {
                window.FX.STATIC.submitRule = res.data.submitRule;
              }
              let flow = null;
              if (flowType) {
                flow = BsyUtils.getFlowOption(res.data, flowType);
              }
              // 是否是流程表 且开启流程
              const isFlowForm = !res.data.hasCoop && res.data.hasFlow;
              formConfig = {
                ...res.data,
                appId: appId || window.FX.STATIC.APPID,
                entryId: entryId,
                originPrint: that.options.originPrint,
                formId: formId || entryId,
                dataId: dataId,
                refAppId: refAppId,
                content: {
                  ...res.data.form,
                  appId: appId || window.FX.STATIC.APPID,
                  entryId: entryId,
                  authGroupId: authGroupId,
                  formId: formId || entryId,
                  dataId: dataId,
                  data,
                  widgetOptAuth: optAuth,
                  flow: flow,
                  ignoreOptAuth: ignoreOptAuth,
                  submitUrl: "/data/update",
                  submitData: {
                    dataId: dataId,
                    flowId: flowId,
                  },
                  title: !flow
                    ? res.data.formName
                    : [res.data.formName, res.data.flowName].join("-"),
                  multiTabs: res.data.formTabs,
                  formTabsStyle: res.data.formTabsStyle || {},
                  tabs: res.data.tabs,
                  width: that.options.width || "80%",
                  hasFlowLog: isFlowForm
                    ? ignoreOptAuth
                      ? true
                      : dataPerms
                      ? dataPerms.flow_log
                      : this.config.hasFlowLog
                    : false,
                  hasLog: ignoreOptAuth
                    ? true
                    : dataPerms
                    ? dataPerms.log
                    : this.config.hasLog,
                  hasFlow: res.data.hasFlow,
                  hasLogView: this.config.hasLogView ?? res.data.hasLogView,
                  hasComment: ignoreOptAuth
                    ? true
                    : dataPerms
                    ? dataPerms.comment
                    : this.config.hasComment,
                  allowSignTypes: res.data.allowSignTypes,
                  flowType: flowType,
                  flowId: res.data.currentFlowId,
                  buttonPosition: "middle",
                  editValue: res.data.data,
                  mode: "edit",
                  popupFormPath: popupFormPath,
                },
              };
            } else if (flowType === "todo" && res.data.isEditable) {
              let flow = null;
              if (flowType) {
                flow = BsyUtils.getFlowOption(res.data, flowType);
              }
              // 是否是流程表 且开启流程
              const isFlowForm = !res.data.hasCoop && res.data.hasFlow;
              formConfig = {
                ...res.data,
                appId: appId || window.FX.STATIC.APPID,
                entryId: entryId,
                originPrint: that.options.originPrint,
                formId: formId || entryId,
                dataId: dataId,
                refAppId: refAppId,
                content: {
                  ...res.data.form,
                  appId: appId || window.FX.STATIC.APPID,
                  entryId: entryId,
                  authGroupId: authGroupId,
                  formId: formId || entryId,
                  dataId: dataId,
                  data,
                  widgetOptAuth: optAuth,
                  flow: flow,
                  ignoreOptAuth: ignoreOptAuth,
                  submitUrl: "/data/update",
                  submitData: {
                    dataId: dataId,
                    flowId: flowId,
                  },
                  title: !flow
                    ? res.data.formName
                    : [res.data.formName, res.data.flowName].join("-"),
                  multiTabs: res.data.formTabs,
                  formTabsStyle: res.data.formTabsStyle || {},
                  tabs: res.data.tabs,
                  width: that.options.width || "80%",
                  hasFlowLog: isFlowForm
                    ? ignoreOptAuth
                      ? true
                      : dataPerms
                      ? dataPerms.flow_log
                      : res.data.hasFlowLog || res.data.hasLogView
                    : false,
                  hasLog: ignoreOptAuth
                    ? true
                    : dataPerms
                    ? dataPerms.log
                    : res.data.log,
                  hasFlow: res.data.hasFlow,
                  hasLogView: this.config.hasLogView
                    ? this.config.hasLogView
                    : res.data.hasLogView,
                  hasComment: ignoreOptAuth
                    ? true
                    : dataPerms
                    ? dataPerms.comment
                    : res.data.hasComment,
                  allowSignTypes: res.data.allowSignTypes,
                  flowType: flowType,
                  flowId: res.data.currentFlowId,
                  buttonPosition: "middle",
                  editValue: res.data.data,
                  mode: "edit",
                  popupFormPath: popupFormPath,
                },
              };
            } else if (flowType === "launch") {
              authGroupId = -1; //工作台，流程提交要-1的权限
              let entryData = res.data;
              const formData = entryData.entry;
              window.FX.STATIC.IS_EVENT = formData.content.isEvent === true;
              if (formData.content.submitRule === 1) {
                window.FX.STATIC.submitRule = formData.content.submitRule;
              }
              formConfig = {
                ...formData,
                is_dock_form: entryData.is_dock_form,
                appId: formData.appId,
                entryId: formData.entryId,
                refAppId: refAppId,
              };
            } else {
              let that = this;
              let formData = res.data;
              let flow = BsyUtils.getFlowOption(res.data, flowType);
              let h = null;

              if (res.data.form && "grid-2" === res.data.form.layout) {
                h = {};
                BsyUtils.forEach(res.data.form.items, function (a, b) {
                  h[b.widget.widgetName] = b.lineWidth;
                });
              }
              if (flow) {
                flow.flowNodes = res.data.flowNodes;
              }
              // formData.form && "grid-2" === formData.form.layout && (h = {},
              //     BsyUtils.forEach(f, function(a, b) {
              //         h[b.widget.widgetName] = b.lineWidth
              //     }))

              var title = "";
              if (formData.hasOwnProperty("flowName")) {
                title = formData.formName; // + "-" + a.flowName;
                // b.flowNodes = [];
              } else {
                if (formData.flowNodes.length === 1) {
                  title = formData.formName + "-" + formData.flowNodes[0].name;
                }
              }
              this.options.flowId =
                formData.currentFlowId == 0
                  ? formData.flowNodes.length
                    ? formData.flowNodes[0].flowId
                    : formData.currentFlowId
                  : formData.currentFlowId;
              let config = {
                form: formData.form,
                appId: appId || window.FX.STATIC.APPID,
                entryId: entryId,
                formId: entryId,
                forms: [entryId],
                // originPrint:e.originPrint ,
                height: "100%",
                title: title,
                formName: formData.formName,
                // form: d.form,
                items: formData.form.items,
                subformFieldShowRules: formData.form.subformFieldShowRules,
                fieldShowRules: formData.form.fieldShowRules,
                multiTabs: formData.formTabs,
                formTabsStyle: formData.formTabsStyle || {},
                hasShowFieldsBtn: !1,
                layout: h,
                header: formData.form.items,
                data: formData.data,
                dataId: formData.data._id,
                flow: flow,
                hasShareBtn: !1,
                hasComment: window.FX.STATIC.FTOKEN ? !1 : !0,
                hasLog: formData.log,
                hasFlow: formData.hasFlow,
                hasFlowLog: formData.hasLogView === true ? true : false, //流程操作日志
                hasLogView: formData.hasLogView === true ? true : false, //流程流转图
                optAuth: formData.optAuth,
                hasFlowBtn: window.FX.STATIC.FTOKEN ? !1 : formData.hasFlowBtn, //(formData.hasFlowBtn && !c),
                hasFooter: !0,
                hasCustomPrint:
                  formData.printId === null || formData.printId === "system"
                    ? !1
                    : !0,
                ignoreVisible: !1,
                flowType: flowType,
                flowId: this.options.flowId || formData.currentFlowId,
                onClose: this.props.onClose,
                onFlowNodeClick: function (flowId) {
                  that.renderFormDataIndex++;
                  that.showForms[that.showFormIndex].flowId = flowId;
                  that.readData();
                },
              };
              this.showForms[this.showFormIndex] = config;
            }

            let mode =
              that.state.isFlow === true
                ? res.data.isEditable
                  ? "edit"
                  : "view"
                : "edit";
            if (flowType) {
              mode =
                flowType === "todo" && res.data.isEditable
                  ? "edit"
                  : flowType === "launch"
                  ? "new"
                  : "view";
            }

            this.setState({
              authGroupId: authGroupId,
              mode: mode,
              loading: false,
              formConfig: formConfig,
            });
          },
          () => {}
        );
      })
      .catch((res) => {
        console.error(res);
        this.setState(
          {
            loading: false,
          },
          () => {
            this.config.onClose && this.config.onClose();
          }
        );
      });
  };

  mergeData = (arg) => {
    const { allShowFields, fields, data } = this.config;
    let newData = { ...data };
    BsyUtils.forEach(allShowFields || fields, (a1, b1) => {
      if (b1.name && arg[b1.name]) {
        let val = arg[b1.name];
        if (b1.type === "linkdata") {
          if (val && BsyUtils.isString(val)) {
            val = JSON.parse(val);
          }
        }

        newData[b1.name] = val;
        if (b1.tag) {
          newData[b1.tag] = val;
        }
      }
    });
    return newData;
  };

  rowdataEditFrom = (fconfig) => {
    let that = this;
    let layerRef = null;
    BsyMaskLayer({
      // customCls: 'fadein-right',
      onContentCreate: (ref) => {
        layerRef = ref;
        this.isEdit = false;

        const {
          appId,
          ignoreAuth,
          ignoreVisible,
          dataPerms,
          sourceType,
          _id,
          dataId,
          entryId,
          flowId,
          flowType,
          formId,
          popupFormPath,
          ignoreOptAuth,
          optAuth,
          data,
          hasLogView,
          refAppId,
        } = this.config;

        // 是否是流程表 且开启流程
        const isFlowForm = !fconfig.hasCoop && fconfig.hasFlow;

        let flow = null;
        if (isFlowForm) {
          flow = BsyUtils.getFlowOption(fconfig, flowType);
        }
        let formConfig = {
          appId: appId || window.FX.STATIC.APPID,
          entryId: entryId,
          originPrint: that.options.originPrint,
          formId: formId || entryId,
          refAppId: refAppId,
          dataId: _id || dataId,
          formTabs: fconfig.multiTabs,
          formTabsStyle: fconfig.formTabsStyle || {},
          content: {
            ...fconfig.form,
            appId: appId || window.FX.STATIC.APPID,
            entryId: entryId,
            authGroupId: 0,
            formId: formId || entryId,
            dataId: _id || dataId,
            data,
            widgetOptAuth: fconfig.optAuth || optAuth,
            flow: flow,
            ignoreOptAuth: false,
            submitUrl: "/data/update",
            submitData: {
              dataId: _id || dataId,
              flowId: flowId,
            },
            title: !flow
              ? fconfig.formName
              : [fconfig.formName, fconfig.flowName].join("-"),
            formTabs: fconfig.multiTabs,
            formTabsStyle: fconfig.formTabsStyle || {},
            tabs: fconfig.tabs,
            width: "80%",
            hasFlowLog: false,
            hasLog: false,
            hasFlow: fconfig.hasFlow,
            hasLogView: false,
            hasComment: false,
            allowSignTypes: fconfig.allowSignTypes,
            flowType: flowType,
            flowId: fconfig.flowId,
            buttonPosition: "middle",
            editValue: fconfig.data,
            mode: "edit",
            popupFormPath: popupFormPath,
            extDashData: fconfig.extDashData,
          },
        };
        let config = {
          appId,
          _id,
          dataId,
          entryId,
          flowId,
          flowType,
          formId,
          data,
          dataPerms,
          sourceType,
          widgetOptAuth: fconfig.optAuth || optAuth,
          authGroupId: 0,
          popupFormPath,
          ignoreOptAuth,
          ignoreAuth,
          ignoreVisible,
          formConfig,
          hasLogView,
          refAppId,
        };
        const { restore } = BsyUtils.globalIdManager(
          config.appId,
          config.entryId,
          config.dataId,
          config?.formConfig?._id
        );
        return (
          <BsyFormPane
            {...config}
            loading={true}
            mode={"edit"}
            authGroupId={0}
            rowdata={true}
            onClose={(status, data) => {
              this.isEdit = status;
              this.config.onClose && this.config.onClose(status, data);
              restore();
              layerRef && layerRef.close();
              return;
            }}
          />
        );
      },
    });
  };

  readFormData = () => {
    let {
      appId,
      _id,
      dataId,
      entryId,
      formId,
      popupFormPath,
      header,
      entrance,
      refAppId,
    } = this.config;

    if (entrance === "report") {
      let n = {
        appId,
        dataId: _id || dataId,
        entryId,
        fields: header,
        popupFormPath,
        formId: formId ? formId : entryId,
        iseditable: false,
        formulas: [],
        refAppId,
      };
      if (this.props.widgetId) {
        n = { ...n, widgetId: this.props.widgetId };
      }
      React.axios("/data/read", n).then((res) => {
        let data = res.data.data;
        header.map((item) => {
          data[item.tag] = data[item.name];
          return null;
        });

        this.showForms[this.showFormIndex].data = data;
        this.setState({ mode: "view" });
      });
      return;
    }

    this.setState({ mode: "view" });
  };

  viewForm = () => {
    let that = this;
    this.config = { ...this.showForms[this.showFormIndex] };
    let {
      appId,
      ignoreAuth,
      ignoreVisible,
      dataPerms,
      sourceType,
      _id,
      dataId,
      entryId,
      flowId,
      flowType,
      formId,
      authGroupId,
      popupFormPath,
      ignoreOptAuth,
      optAuth,
      formConfig,
      originPrint,
    } = this.config;
    return (
      <BsyFormData
        key={"BsyFormData" + this.renderFormDataIndex}
        // entrance={this.props.entrance}
        {...this.config}
        ref={this.formdataElement}
        hasRecoverBtn={this.config.isBackup ? true : false}
        height={"100%"}
        isLink={this.props.isLink}
        showForms={this.showForms}
        showFormIndex={this.showFormIndex}
        onSwitchForm={(index) => {
          this.showForms.splice(index + 1, this.showForms.length - index - 1);
          this.showFormIndex = index;
          this.renderFormDataIndex++;
          this.setState({ mode: "view" });
        }}
        onCloseFlow={() => {
          if (this.config.onCloseFlow) {
            this.config.onCloseFlow();
          } else {
            BsyAlert({
              title: React.language("flow.close"),
              msg: React.language("flow.close.tip"),
              type: "warning",
              text4Ok: React.language("ok"),
              OkType: "blue",
              text4Cancel: React.language("cancel"),
              ok: () => {
                //   const { appId, entryId, authGroupId } = this.state;
                let n = {
                  appId: appId,
                  entryId: entryId,
                  formId: entryId,
                  dataId: dataId,
                  authGroupId: authGroupId,
                  popupFormPath: popupFormPath,
                  // extDashData: this.props.extDashData
                };

                let layerRef = null;
                BsyMaskLayer({
                  customCls: "sloading",
                  onContentCreate: (ref) => {
                    layerRef = ref;
                    return (
                      <div>
                        <BsySLoading />{" "}
                      </div>
                    );
                  },
                });

                React.axios("/data/close_flow", n).then(() => {
                  //   that.componentContext.reload();
                  layerRef && layerRef.close();
                  BsyUtils.applyFunc(this, this.props.onClose, [true], !1);
                });
              },
            });
          }
        }}
        onRecoverData={(id, status) => {
          this.config.onRecoverData && this.config.onRecoverData(id, status);
        }}
        onSwitchData={(t) => {
          // let data =
          if (this.config && this.config.onSwitchData)
            this.config.onSwitchData(t);
        }}
        onShowData={(data) => {
          this.showForms.push(data);
          this.showFormIndex++;
          this.renderFormDataIndex++;
          this.setState({ mode: "view" });
        }}
        onCopyData={(fconfig) => {
          let layerRef = null;
          BsyMaskLayer({
            // customCls: 'fadein-right',
            onContentCreate: (ref) => {
              layerRef = ref;
              this.isEdit = false;

              let copyPopupFormPath = undefined;
              if (
                popupFormPath &&
                // originPrint === "report" &&
                popupFormPath.length
              ) {
                popupFormPath[popupFormPath.length - 1].menuId = "create";
                popupFormPath[popupFormPath.length - 1].menuType = "menu";
                copyPopupFormPath = _.cloneDeep(popupFormPath);
              }
              if (fconfig.formConfig) {
                fconfig.formConfig = undefined;
              }
              let config = {
                ...fconfig,
                appId,
                _id,
                dataId: null,
                entryId,
                flowId,
                flowType,
                formId,
                data: fconfig.data,
                dataPerms,
                sourceType,
                extDashData: this.props.extDashData,
                widgetOptAuth: optAuth || fconfig.optAuth,
                authGroupId:
                  fconfig.dataUrl === "/data/dash_process_data"
                    ? 0
                    : authGroupId,
                popupFormPath:
                  fconfig.dataUrl === "/data/dash_process_data"
                    ? undefined
                    : copyPopupFormPath,
                ignoreOptAuth,
                ignoreAuth,
                ignoreVisible,
                // hasLogView,
              };

              const { restore } = BsyUtils.globalIdManager(
                config.appId,
                config.entryId,
                config.dataId,
                config?.formConfig?._id
              );
              // TODO 修复报表编剧是权限不对问题需要传入-99

              return (
                <BsyFormPane
                  {...config}
                  loading={true}
                  mode={"copy"}
                  onClose={(status) => {
                    restore();
                    layerRef && layerRef.close();
                    this.config.onClose && this.config.onClose(status);
                  }}
                />
              );
            },
          });
        }}
        onEditData={(fconfig) => {
          // this.config = {...this.config,...config};
          if (this.config.dataUrl === "/data/dash_process_data") {
            this.rowdataEditFrom(fconfig);
            return;
          }

          let layerRef = null;
          BsyMaskLayer({
            // customCls: 'fadein-right',
            onContentCreate: (ref) => {
              layerRef = ref;
              this.isEdit = false;

              let {
                appId,
                ignoreAuth,
                ignoreVisible,
                dataPerms,
                sourceType,
                _id,
                dataId,
                entryId,
                flowId,
                flowType,
                formId,
                authGroupId,
                popupFormPath,
                ignoreOptAuth,
                optAuth,
                data,
              } = this.config;

              //可能出现跨应用表单的情况，需要重置
              // if (formConfig) {
              //     formConfig.appId = appId;
              //     formConfig.entryId = entryId;
              //     formConfig.formId = formId;
              //     formConfig.content.pcLayout = fconfig.form.pcLayout;

              // }

              // 2024 02 29 不清楚什么原因增加的，在实际场景编辑模式不需要
              // if (
              //   popupFormPath &&
              //   originPrint == "report" &&
              //   popupFormPath.length
              // ) {
              //   popupFormPath[popupFormPath.length - 1].menuId = "create";
              //   popupFormPath[popupFormPath.length - 1].menuType = "menu";
              // }
              if (fconfig.formConfig) {
                fconfig.formConfig = undefined;
              }
              let config = {
                ...fconfig,
                width: that.element.current.style.width,
                appId,
                _id,
                dataId,
                entryId,
                flowId,
                flowType,
                formId,
                data,
                dataPerms,
                sourceType,
                widgetOptAuth: optAuth || fconfig.optAuth,
                authGroupId,
                popupFormPath,
                ignoreOptAuth,
                ignoreAuth,
                ignoreVisible,
                // formConfig,
                // hasLogView,
              };
              const { restore } = BsyUtils.globalIdManager(
                config.appId,
                config.entryId,
                config.dataId,
                config?.formConfig?._id
              );
              // TODO 修复报表编剧是权限不对问题需要传入-99
              return (
                <BsyFormPane
                  {...config}
                  loading={true}
                  mode={"edit"}
                  authGroupId={
                    BsyUtils.isNull(this.props.authGroupId) &&
                    !config.ignoreAuth
                      ? -99
                      : this.props.authGroupId
                  }
                  rowdata={
                    this.config &&
                    this.config.dataUrl === "/data/dash_process_data"
                      ? true
                      : false
                  }
                  onClose={(status, data) => {
                    restore();
                    this.isEdit = status;

                    if (
                      this.config &&
                      this.config.dataUrl === "/data/dash_process_data"
                    ) {
                      this.config.onClose && this.config.onClose(status, data);
                      layerRef && layerRef.close();
                      return;
                    }

                    if (status) {
                      this.renderFormDataIndex++;
                      this.showForms[this.showFormIndex].data =
                        this.mergeData(data);

                      this.readFormData();
                    }

                    layerRef && layerRef.close();
                    // this.config.onClose && this.config.onClose(status);
                  }}
                />
              );
            },
          });
        }}
        onRefresh={(data) => {
          this.renderFormDataIndex++;
          this.showForms[this.showFormIndex].data = this.mergeData(data);
          this.isEdit = true;
          this.forceUpdate();
        }}
        onClose={(status, reshow) => {
          this.renderFormDataIndex++;
          if (this.showFormIndex == 0) {
            this.config.onClose && this.config.onClose(this.isEdit, reshow);
            return;
          }

          if (this.showFormIndex > 0) {
            this.showForms.pop();
            this.showFormIndex = this.showForms.length - 1;
          }
          this.setState({ mode: "view" });
          BsyUtils.applyFunc(this, this.props.onClose, [this.isEdit], !1);
        }}
      ></BsyFormData>
    );
  };

  printForm = () => {
    this.config = { ...this.showForms[this.showFormIndex] };
    return (
      <BsyFormData
        key={"BsyFormData" + this.renderFormDataIndex}
        {...this.config}
        form={{ items: this.config.header }}
        originPrint={"flow"}
        entrance={"form"}
        hasRecoverBtn={false}
        height={"100%"}
        showForms={this.showForms}
        showFormIndex={0}
        onClose={() => {
          BsyUtils.applyFunc(this, this.props.onClose, [!0], !1);
        }}
      ></BsyFormData>
    );
  };

  showPrintPane = (formConfig, data) => {
    var n = {
      appId: formConfig.appId,
      entryId: formConfig.entryId,
      formId: formConfig.formId || formConfig.entryId,
      dataId: data.data._id,
      flowType: "print",
      flowId: formConfig.currentFlowId || 0,
    };
    if (this.props.widgetId) {
      n = { ...n, widgetId: this.props.widgetId };
    }
    React.axios("/data/read", n)
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            let layerRefprint = null;
            BsyMaskLayer({
              // customCls: 'fadein-right',
              onContentCreate: (ref) => {
                layerRefprint = ref;
                formConfig.currentFlowId = n.flowId;
                formConfig.optAuth = res.data.optAuth;
                formConfig.data = res.data.data;
                let flow = formConfig.flow;
                formConfig.flowType = "print";
                if (formConfig.flowType && !formConfig.flow) {
                  flow = BsyUtils.getFlowOption(
                    formConfig,
                    formConfig.flowType
                  );
                  // e.flow = flow;
                }
                flow.flowId = n.flowId;
                let config = {
                  // dataUrl: dataUrl,
                  appId: formConfig.appId,
                  entryId: formConfig.entryId,
                  formId: formConfig.formId || formConfig.entryId,
                  origin: n.origin,
                  header: res.data.form.items,
                  optAuth: formConfig.optAuth,
                  flow,
                  flowType: formConfig.flowType,
                  // flowId: formConfig.currentFlowId || 0,
                  originPrint: n.originPrint,
                  items: formConfig.content.items || [],
                  ignoreOptAuth: n.ignoreOptAuth,
                  ignoreAuth: n.ignoreAuth,
                  ignoreValidate: n.ignoreValidate,
                  ignoreVisible: n.ignoreAuth,

                  needFetchViewData: false,
                  hasShowFieldsBtn: n.hasShowFieldsBtn || n.needFetchViewData,

                  ptlist: [],
                  hasShareBtn: false,

                  width: "80%",
                  forms: [formConfig.entryId],

                  hasComment: formConfig.hasComment,
                  hasCoop: formConfig.hasCoop,
                  hasFlow: formConfig.hasFlow,
                  hasFlowAssist: formConfig.hasFlowAssist,
                  hasLogView: formConfig.hasLogView,
                  hasFlowLog: formConfig.hasLogView,
                  hasPrint: formConfig.hasPrint,
                  isEditable: formConfig.isEditable,
                  is_dock_form: formConfig.is_dock_form,
                  log: formConfig.log,
                  data: formConfig.data,
                  multiTabs: null,

                  title: formConfig.formName,
                  isBackup: false,
                  height: "100%",
                  hasSwitchBtn: false,
                  hasPrintBtn: n.recycle ? !1 : !0,
                  hasCustomPrint: !0,

                  hasEditBtn: false,
                  hasDeleteBtn: false,
                  hasRecoverBtn: false,
                  // hasLog: hasLog,
                  // hasComment: hasComment,
                  enableRowEdit: false,
                  quickEdit: false,
                  extDashData: null,
                  authGroupId: null,
                  dataPerms: null,
                };
                const { restore } = BsyUtils.globalIdManager(
                  config.appId,
                  config.entryId,
                  config.dataId,
                  config?.formConfig?._id
                );
                return (
                  <BsyFormPane
                    {...config}
                    loading={false}
                    mode={"print"}
                    onClose={() => {
                      restore();
                      layerRefprint && layerRefprint.close();
                    }}
                  />
                );
              },
            });
          },
          () => {}
        );
      })
      .catch(() => {
        this.config.onClose && this.config.onClose();
      });
  };

  editForm = () => {
    const {
      formConfig,
      authGroupId,
      buttonPosition,
      mode,
      ignoreAuth,
      ignoreOptAuth,
      ignoreValidate,
    } = this.state;
    if (!formConfig) {
      return "";
    }
    const { popupFormPath, extDashData } = this.config;
    // ignoreAuth={_opt.ignoreAuth}
    // ignoreOptAuth={_opt.ignoreOptAuth}
    // ignoreValidate={_opt.ignoreValidate}
    let that = this;
    window.FX.STATIC.IS_EVENT = formConfig.isEvent === true;
    window.FX.STATIC.entryId = formConfig.entryId;
    window.FX.STATIC.ENTRYID = formConfig.entryId;

    let config = {
      ...formConfig.content,
      editValue: mode !== "new" ? formConfig.content.editValue : null,
      ignoreAuth,
      ignoreOptAuth,
      ignoreValidate,
      widgetOptAuth:
        mode === "copy"
          ? undefined
          : this.props.widgetOptAuth || formConfig.optAuth,
      appId: formConfig.appId,
      entryId: formConfig.entryId,
      formId: formConfig.formId || formConfig.entryId,
      refAppId: formConfig.refAppId,
      width: formConfig.content.width || "100%",
      enableRowEdit: formConfig.enableRowEdit,
      quickEdit: formConfig.quickEdit,
      is_dock_form: formConfig.is_dock_form,
      title: formConfig.title || formConfig.name || formConfig.formName,
      hasHeader: this.props.hasOwnProperty("hasHeader")
        ? this.props.hasHeader
        : true,
      hasFlow: formConfig.hasFlow && !formConfig.hasCoop,
      hasFlowPrint: formConfig.hasFlowPrint,
      needSpecifyCreatorDept: formConfig.needSpecifyCreatorDept,
      multiTabs: formConfig.formTabs,
      formTabsStyle: formConfig.formTabsStyle || {},
      flows: formConfig.flow,
      isEvent: formConfig.isEvent,
      height: "100%",
      authGroupId: authGroupId,
      extDashData: extDashData,
      mode: mode,
      formTheme: window.FX.STATIC.RTOKEN ? formConfig.theme : null,
      submitUrl: mode === "edit" ? "/data/update" : "/data/create",
      submitText:
        mode === "edit" ? React.language("modify") : React.language("submit"),
      hasFooter:
        mode === "edit"
          ? true
          : ignoreAuth
          ? true
          : formConfig.content
          ? formConfig.content.isSubmit
            ? formConfig.content.isSubmit === "yes"
              ? !0
              : !1
            : !0
          : !0,
      printText: formConfig.hasFlowPrint ? formConfig.flow.print_text : null,
      buttonPosition: buttonPosition,
      popupFormPath: popupFormPath,
      onClose: this.props.onClose,
      isLink: this.props.isLink,
      onSuccess: function (a, d, e) {
        const { data, flowAction, needPrint, values } = a;
        window.FX.STATIC.DATAID = null;
        BsyUtils.applyFunc(that, formConfig.onWriteBackForm, [values], !1);

        if (data.error_code) {
          let title = React.language("form.submit.fail.charger");
          let msg = React.language("form.submit.fail.charger.desc");
          if (a.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND) {
            title = React.language("form.submit.fail.cond");
            msg = React.language("form.submit.fail.cond.desc");
          } else if (
            a.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_SUBFLOW
          ) {
            title = React.language("form.submit.fail.subflow");
            msg = React.language("form.submit.fail.subflow.desc");
          } else if (
            a.error_code === window.FX.CONST.FLOW_FAIL_CODE.FORWARD_approval
          ) {
            title = React.language("form.submit.fail.approval");
            msg = React.language("form.submit.fail.approval.desc");
          }

          BsyAlert({
            title: title,
            msg: msg,
            type: "warning",
            text4Cancel: null,
            text4Ok: React.language("iSee"),
          });
          if (mode === "new") e.regenerationSubformId();
          //？？？ 主动调数据，去刷新子表单的ID OK？？？？
          // that.props.onClose && that.props.onClose(true, that.options.data) //此类错误需要关闭界面，否则会出现子表单ID报错的情况
          return;
        }
        that.flowAction = d;

        if (needPrint) {
          that.showPrintPane(formConfig, data);
        }
        // TODO 修复首页流程代办那发起流程功能
        if (that.props.flowType) {
          if (that.props.source === "flow-message" && needPrint) {
            that.setState({
              mode: "showsubmit",
              flowAction,
              needPrint,
              submitDatas: data,
            });
            return;
          }

          that.props.onSuccess?.(true, a);
          return;
        }
        if (mode === "copy") {
          that.props.onClose && that.props.onClose(true, that.options.data);
          return;
        }

        if (mode != "new") {
          that.options.data = { ...that.options.data, ...data.data };
          that.renderFormDataIndex++;
          that.isEdit = true;
          that.props.onClose && that.props.onClose(true, that.options.data);
          return;
        }

        if (
          authGroupId != -1 &&
          that.props.onClose &&
          data.submitPrompt &&
          data.submitPrompt.popupAutoClose
        ) {
          that.props.onClose &&
            that.props.onClose(true, that.options.data, true);
          return;
        }
        if (config.hasHeader === false || formConfig.Outside) {
          if (BsyUtils.hasHref(formConfig.href)) {
            let hasBlank = formConfig.href;
            let data1 = { ...values, ...data.retdata };
            let data2 = {};
            BsyUtils.forEach(data1, (obj, res) => {
              data2[obj] = {
                data: res,
              };
            });
            data2._id = {
              data: data.dataId,
            };
            window.FX.STATIC.FORMHREF = formConfig.href;
            BsyUtils.href(data2);
            if (hasBlank) {
              that.renderIndex++;
              that.setState({
                mode: "showsubmit",
                flowAction,
                needPrint,
                submitDatas: data,
              });
            }
          } else {
            that.renderIndex++;
            that.setState({
              mode: "showsubmit",
              flowAction,
              needPrint,
              submitDatas: data,
            });
          }
        } else {
          that.renderIndex++;
          that.setState({
            mode: "showsubmit",
            flowAction,
            needPrint,
            submitDatas: data,
          });
        }
        // }
      },
      onError: function (a) {
        const { data } = a;
        if (mode != "new") {
          if (data.error_code) {
            that.props.onClose && that.props.onClose(true, that.options.data);
          }
          return;
        }
        // window.$(c.content.current).empty();
        // window.BsyUtils.showErrorInfo(window.$(c.content.current), a, function () {
        //     window.FX.STATIC.IS_EVENT ? c._loadContentByAgainAdd(b, authGroupId) : c._createFormView(b, authGroupId);
        // })
      },
    };

    BsyUtils.forEach(config.userOrDeptMap || {}, (obj, res) => {
      if (res.mode === "member") {
        window.userSelectMap[res.id] = {
          ...res,
          _id: res.id,
          nickName: res.name,
        };
      } else {
        window.deptSelectMap[res.id] = {
          ...res,
          _id: res.id,
          name: res.name,
        };
      }
    });

    return <BsyForm {...config} />;
  };

  submitPane = () => {
    const { submitDatas, flowAction, formConfig } = this.state;
    const { isLink } = this.props;
    let a = submitDatas.submitPrompt;

    var reg = /<a.*?>(.*?)<\/a>/gi;
    if (a) {
      var contArray = reg.exec(a.content);
      var contA = "";
      if (contArray != null) {
        contA = contArray[0];
        var regexp = new RegExp(contA, "g");
        var des = window.FX.Utils.replaceDescription(contA);
        a.content = a.content.replace(regexp, des);
      }
    }

    let cls =
      submitDatas.check_code === 3334 ? " waring-pane " : " success-pane ";

    let text = React.language("submit.success");
    if (flowAction) {
      text = React.language("flow.action." + flowAction + ".success");
    }
    let hasHeader = this.props.hasOwnProperty("hasHeader")
      ? this.props.hasHeader
      : false;

    return (
      <div className="bsy-form" style={{ height: "100%" }}>
        {hasHeader ? (
          <div
            className="bsy-header"
            style={{ minHeight: 50, lineHeight: "50px" }}
          >
            <span className="title">
              {formConfig.content.name || formConfig.name}
            </span>
            <i
              className="icon-close-large form-exit-icon"
              onClick={() => {
                this.props.onClose && this.props.onClose(true);
              }}
            ></i>
          </div>
        ) : (
          ""
        )}

        {a && "custom" === a.mode ? (
          <div className={cls + (hasHeader ? "has-header " : " ") + a.mode}>
            <div
              dangerouslySetInnerHTML={{
                __html: BsyUtils.escapeHtmlScriptSpecialChar(
                  a && "custom" === a.mode ? a.content : ""
                ),
              }}
            ></div>
            {a.hasAddBtn ? (
              <div className="button-pane">
                <BsyIconBtn
                  text={React.language("form.submit.continue")}
                  click={() => {
                    this.setState({
                      mode: "new",
                    });
                  }}
                  type={"blue"}
                ></BsyIconBtn>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <>
            {this.props.source != "flow-message" ? (
              <div className={cls + (hasHeader ? "has-header " : " ")}>
                <div>
                  {" "}
                  <i className="img-icon"> </i>
                </div>
                <div className="msg-title">{text}</div>
                <div
                  className="msg-info"
                  dangerouslySetInnerHTML={{
                    __html: BsyUtils.escapeHtmlScriptSpecialChar(
                      submitDatas.check_msg ? submitDatas.check_msg : ""
                    ),
                  }}
                ></div>
                <div className="button-pane">
                  <BsyIconBtn
                    text={React.language("form.submit.continue")}
                    click={() => {
                      this.setState({
                        mode: "new",
                      });
                    }}
                    type={"blue"}
                  ></BsyIconBtn>
                </div>
              </div>
            ) : (
              <div className={cls + (hasHeader ? "has-header " : " ")}>
                <div>
                  {" "}
                  <i className="img-icon"> </i>
                </div>
                <div className="msg-title">{}</div>

                <div className="button-pane">
                  <BsyIconBtn
                    text={React.language("goHome")}
                    click={() => {
                      window.location.href = `${window.rootDirectroy}/team/app/${formConfig.appId}`;
                    }}
                    type={"blue"}
                  ></BsyIconBtn>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  renderDD = () => {
    const { mode } = this.state;
    switch (mode) {
      case "new":
      case "copy":
      case "edit":
        return this.editForm();
      case "showsubmit":
        return this.submitPane();
      case "view": {
        return this.viewForm();
      }
      case "print": {
        return this.printForm();
      }
      default:
        return "";
    }
  };

  render() {
    const { cssName, width } = this.options;
    const { mode, loading } = this.state;

    let css = cssName;
    if (mode === "showsubmit") {
      css = css + " bsy-form-success ";
    }

    return (
      <div className={css} style={{ width: width }} ref={this.element}>
        {loading ? <BsySLoading /> : this.renderDD()}
      </div>
    );
  }
}

export default BsyFormPane;
